import {LoaderFunctionArgs, RouteObject, RouterContextProvider, redirect} from 'react-router';

import {EResellerIds, getTenantData} from 'src/containers/User';
import {getDispatch} from 'src/routerContext';

import {integrationSettingsRoutes} from '../IntegrationSettings/routes';
import {EIntegrationTabs} from './index';

const checkBlrReseller = async (context: RouterContextProvider) => {
  const dispatch = getDispatch(context);
  const {data: tenant} = await dispatch(getTenantData.initiate());

  if (!tenant) {
    return false;
  }

  return [EResellerIds.BLR_FIRST_ID, EResellerIds.BLR_SECOND_ID].includes(tenant.resellerId);
};

const blrPathLoader = async ({context}: LoaderFunctionArgs) => {
  const isBLRReseller = await checkBlrReseller(context);

  if (!isBLRReseller) {
    return null;
  }

  throw redirect(`../${EIntegrationTabs.DOCUMENTATION}`);
};

const children: RouteObject[] = [
  {
    index: true,
    loader: () => redirect(EIntegrationTabs.DOCUMENTATION),
  },
  {
    path: EIntegrationTabs.DOCUMENTATION,
    lazy: async () => ({
      Component: (await import('./Documentation')).default,
    }),
  },
  {
    path: EIntegrationTabs.SETTINGS,
    lazy: async () => ({
      Component: (await import('src/containers/IntegrationSettings')).IntegrationSettings,
    }),
    ...integrationSettingsRoutes,
  },
  {
    path: EIntegrationTabs.TESTING,
    loader: blrPathLoader,
    lazy: async () => ({
      Component: (await import('./Testing')).default,
    }),
  },
  {
    path: EIntegrationTabs.MODULES,
    loader: blrPathLoader,
    lazy: async () => ({
      Component: (await import('./Modules')).default,
    }),
  },
];

export const integrationRoutes: RouteObject = {
  loader: async ({context}) => {
    const availableTabs: EIntegrationTabs[] = Object.values(EIntegrationTabs);
    const isBLRReseller = await checkBlrReseller(context);

    if (isBLRReseller) {
      return {
        tabs: availableTabs.filter((tab) =>
          [EIntegrationTabs.DOCUMENTATION, EIntegrationTabs.SETTINGS].includes(tab),
        ),
      };
    }

    return {
      tabs: availableTabs,
    };
  },
  children,
};
